import { combineReducers } from 'redux';
import { teamBrandReducer } from './team-brand.reducer';
import { teamJurisdictionReducer } from './team-jurisdiction.reducer';

export const jurisdictionsReducer = combineReducers({
    jurisdiction: teamJurisdictionReducer,
    brand: teamBrandReducer
});
